module.exports = __webpack_public_path__ + "img/logo.a4b45b1d.jpg";